export default __webpack_public_path__ + "static/media/Cang-Jei's Grin.d089946c.jpg";